import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import uiReducer from './app';
import dalReducer from '../lib/dataLayer';
import { CLEAR_STORE } from './actions';

const appReducers = combineReducers({
  dal: dalReducer,
  router: routerReducer,
  ui: uiReducer,
});

const reducer = (state, action) => {
  if (action.type === CLEAR_STORE) {
    state = undefined;
  }

  return appReducers(state, action);
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducer.js